export const businesses = [
  {
    id: '1',
    slug: 'le-pave-lome',
    name: 'Le Pavé',
    logoUrl: 'https://readdy.ai/api/search-image?query=Elegant%20restaurant%20logo%20monogram%20on%20dark%20background%2C%20minimalist%20typography%2C%20gold%20and%20navy%20colors&width=200&height=200&seq=biz-logo-1&orientation=squarish',
    coverUrl: 'https://readdy.ai/api/search-image?query=Upscale%20African%20restaurant%20interior%20with%20warm%20ambient%20lighting%2C%20elegant%20wooden%20furniture%2C%20traditional%20Togolese%20decor%20elements%2C%20night%20atmosphere%2C%20professional%20photography&width=1200&height=500&seq=biz-cover-1&orientation=landscape',
    description: 'Restaurant gastronomique au cœur de Lomé. Cuisine française et togolaise raffinée dans un cadre élégant. Spécialités : grillades, poissons frais, desserts maison.',
    categoryId: '1',
    categoryName: 'Restaurants',
    city: 'Lomé',
    country: 'Togo',
    address: 'Boulevard du 13 Janvier, Lomé',
    phone: '+228 90 12 34 56',
    email: 'contact@lepave.tg',
    website: 'https://lepave.tg',
    rating: 4.7,
    reviewCount: 128,
    isVerified: true,
    status: 'active',
    openingHours: [
      { day: 'Lundi - Vendredi', hours: '11h00 - 23h00' },
      { day: 'Samedi - Dimanche', hours: '11h00 - 00h00' },
    ],
    socialLinks: { facebook: 'https://facebook.com/lepave', instagram: 'https://instagram.com/lepave' },
  },
  {
    id: '2',
    slug: 'hotel-sarakawa',
    name: 'Hôtel Sarakawa',
    logoUrl: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20logo%20emblem%20on%20dark%20background%2C%20crown%20symbol%2C%20silver%20and%20blue%20gradient&width=200&height=200&seq=biz-logo-2&orientation=squarish',
    coverUrl: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20resort%20in%20tropical%20Africa%2C%20swimming%20pool%20at%20sunset%2C%20palm%20trees%2C%20modern%20architecture%2C%20warm%20golden%20light%2C%20professional%20travel%20photography&width=1200&height=500&seq=biz-cover-2&orientation=landscape',
    description: 'Hôtel 4 étoiles emblématique de Lomé. Piscine olympique, spa, restaurant panoramique, salles de conférence. L\'adresse de référence pour les voyageurs d\'affaires et de loisir.',
    categoryId: '2',
    categoryName: 'Hôtels',
    city: 'Lomé',
    country: 'Togo',
    address: 'Route de Kpalimé, Lomé',
    phone: '+228 22 21 00 00',
    email: 'reservation@sarakawa.com',
    website: 'https://sarakawa.com',
    rating: 4.5,
    reviewCount: 342,
    isVerified: true,
    status: 'active',
    openingHours: [
      { day: 'Réception', hours: '24h/24' },
      { day: 'Restaurant', hours: '06h30 - 22h30' },
    ],
    socialLinks: { facebook: 'https://facebook.com/sarakawa', instagram: 'https://instagram.com/sarakawa' },
  },
  {
    id: '3',
    slug: 'pharmacie-centrale-aneho',
    name: 'Pharmacie Centrale',
    logoUrl: 'https://readdy.ai/api/search-image?query=Pharmacy%20cross%20logo%20emblem%2C%20green%20and%20white%20medical%20symbol%20on%20dark%20background%2C%20clean%20professional%20design&width=200&height=200&seq=biz-logo-3&orientation=squarish',
    coverUrl: 'https://readdy.ai/api/search-image?query=Modern%20pharmacy%20storefront%20in%20African%20city%2C%20clean%20bright%20interior%2C%20shelves%20with%20medicines%2C%20professional%20lighting%2C%20healthcare%20environment&width=1200&height=500&seq=biz-cover-3&orientation=landscape',
    description: 'Pharmacie moderne ouverte 7j/7. Vente de médicaments, conseil pharmaceutique, analyses médicales, produits de parapharmacie. Livraison à domicile disponible.',
    categoryId: '5',
    categoryName: 'Pharmacies',
    city: 'Aného',
    country: 'Togo',
    address: 'Rue des Palmiers, Aného',
    phone: '+228 90 45 67 89',
    email: 'pharmaciecentrale@yahoo.fr',
    website: '',
    rating: 4.3,
    reviewCount: 76,
    isVerified: false,
    status: 'active',
    openingHours: [
      { day: 'Lundi - Samedi', hours: '07h00 - 21h00' },
      { day: 'Dimanche', hours: '08h00 - 14h00' },
    ],
    socialLinks: { facebook: 'https://facebook.com/pharmaciecentrale' },
  },
  {
    id: '4',
    slug: 'ecole-superieure-iboct',
    name: 'ESIB-OCT / Université de Lomé',
    logoUrl: 'https://readdy.ai/api/search-image?query=University%20shield%20logo%20emblem%2C%20academic%20crest%20with%20open%20book%2C%20dark%20blue%20and%20gold%20on%20dark%20background&width=200&height=200&seq=biz-logo-4&orientation=squarish',
    coverUrl: 'https://readdy.ai/api/search-image?query=Modern%20university%20campus%20in%20Africa%2C%20large%20buildings%20with%20green%20lawns%2C%20students%20walking%2C%20palm%20trees%2C%20bright%20sunny%20day%2C%20professional%20photography&width=1200&height=500&seq=biz-cover-4&orientation=landscape',
    description: 'École supérieure des sciences et ingénieurs du bâtiment et des travaux publics. Formation de haut niveau en génie civil, architecture et urbanisme. Campus moderne à Lomé.',
    categoryId: '7',
    categoryName: 'Écoles',
    city: 'Lomé',
    country: 'Togo',
    address: 'Campus Universitaire, Lomé',
    phone: '+228 22 25 00 00',
    email: 'contact@esib-oct.tg',
    website: 'https://esib-oct.tg',
    rating: 4.6,
    reviewCount: 215,
    isVerified: true,
    status: 'active',
    openingHours: [
      { day: 'Lundi - Vendredi', hours: '07h30 - 18h00' },
    ],
    socialLinks: { facebook: 'https://facebook.com/esiboct', linkedin: 'https://linkedin.com/school/esib-oct' },
  },
  {
    id: '5',
    slug: 'ecobank-lome-centre',
    name: 'Ecobank Lomé Centre',
    logoUrl: 'https://readdy.ai/api/search-image?query=Bank%20logo%20emblem%2C%20abstract%20geometric%20shield%20shape%2C%20blue%20gradient%20on%20dark%20background%2C%20financial%20institution%20symbol&width=200&height=200&seq=biz-logo-5&orientation=squarish',
    coverUrl: 'https://readdy.ai/api/search-image?query=Modern%20bank%20branch%20interior%20in%20Africa%2C%20sleek%20glass%20and%20steel%20design%2C%20ATM%20area%2C%20customer%20service%20desk%2C%20professional%20lighting%2C%20corporate%20environment&width=1200&height=500&seq=biz-cover-5&orientation=landscape',
    description: 'Agence principale d\'Ecobank au Togo. Services bancaires complets : comptes, prêts, transferts internationaux, e-banking, cartes bancaires. Ouvert du lundi au samedi.',
    categoryId: '8',
    categoryName: 'Banques',
    city: 'Lomé',
    country: 'Togo',
    address: 'Avenue de la Libération, Lomé',
    phone: '+228 22 21 30 30',
    email: 'lomecentre@ecobank.com',
    website: 'https://ecobank.com/tg',
    rating: 4.2,
    reviewCount: 189,
    isVerified: true,
    status: 'active',
    openingHours: [
      { day: 'Lundi - Vendredi', hours: '08h00 - 16h00' },
      { day: 'Samedi', hours: '08h00 - 12h00' },
    ],
    socialLinks: { facebook: 'https://facebook.com/ecobanktogo', twitter: 'https://twitter.com/ecobank_tg' },
  },
  {
    id: '6',
    slug: 'clinique-saint-joseph',
    name: 'Clinique Saint-Joseph',
    logoUrl: 'https://readdy.ai/api/search-image?query=Medical%20clinic%20logo%20emblem%2C%20cross%20with%20heart%20symbol%2C%20red%20and%20white%20on%20dark%20background%2C%20healthcare%20professional%20design&width=200&height=200&seq=biz-logo-6&orientation=squarish',
    coverUrl: 'https://readdy.ai/api/search-image?query=Modern%20medical%20clinic%20exterior%20in%20African%20city%2C%20clean%20white%20building%2C%20ambulance%20area%2C%20palm%20trees%2C%20professional%20healthcare%20photography%2C%20daylight&width=1200&height=500&seq=biz-cover-6&orientation=landscape',
    description: 'Clinique polyvalente de référence à Lomé. Urgences 24h/24, consultations spécialisées, chirurgie, maternité, imagerie médicale. Équipement de pointe et personnel qualifié.',
    categoryId: '6',
    categoryName: 'Cliniques',
    city: 'Lomé',
    country: 'Togo',
    address: 'Rue du Commerce, Lomé',
    phone: '+228 22 20 10 10',
    email: 'contact@cliniquesaintjoseph.tg',
    website: 'https://cliniquesaintjoseph.tg',
    rating: 4.4,
    reviewCount: 156,
    isVerified: true,
    status: 'active',
    openingHours: [
      { day: 'Urgences', hours: '24h/24' },
      { day: 'Consultations', hours: '07h00 - 19h00' },
    ],
    socialLinks: { facebook: 'https://facebook.com/cliniquestjoseph' },
  },
  {
    id: '7',
    slug: 'salon-vip-lome',
    name: 'Salon VIP',
    logoUrl: 'https://readdy.ai/api/search-image?query=Beauty%20salon%20logo%20emblem%2C%20elegant%20silhouette%20of%20woman%2C%20gold%20and%20pink%20gradient%20on%20dark%20background%2C%20luxury%20beauty%20design&width=200&height=200&seq=biz-logo-7&orientation=squarish',
    coverUrl: 'https://readdy.ai/api/search-image?query=Luxury%20beauty%20salon%20interior%20in%20Africa%2C%20modern%20hair%20styling%20stations%2C%20warm%20ambient%20lighting%2C%20mirrors%20with%20LED%20lights%2C%20elegant%20decor%2C%20professional%20photography&width=1200&height=500&seq=biz-cover-7&orientation=landscape',
    description: 'Salon de coiffure et institut de beauté haut de gamme. Coiffure afro et européenne, manucure, pédicure, soins du visage, maquillage. Experts capillaires et esthéticiennes diplômées.',
    categoryId: '9',
    categoryName: 'Salons de beauté',
    city: 'Lomé',
    country: 'Togo',
    address: 'Rue du Grand Marché, Lomé',
    phone: '+228 90 78 90 12',
    email: 'salonvip@hotmail.com',
    website: '',
    rating: 4.8,
    reviewCount: 94,
    isVerified: false,
    status: 'active',
    openingHours: [
      { day: 'Lundi - Samedi', hours: '08h00 - 19h00' },
      { day: 'Dimanche', hours: '10h00 - 16h00' },
    ],
    socialLinks: { instagram: 'https://instagram.com/salonviplome' },
  },
  {
    id: '8',
    slug: 'garage-auto-plus-kara',
    name: 'Garage Auto Plus',
    logoUrl: 'https://readdy.ai/api/search-image?query=Auto%20repair%20garage%20logo%20emblem%2C%20wrench%20and%20gear%20symbol%2C%20orange%20and%20black%20on%20dark%20background%2C%20automotive%20professional%20design&width=200&height=200&seq=biz-logo-8&orientation=squarish',
    coverUrl: 'https://readdy.ai/api/search-image?query=Modern%20auto%20repair%20garage%20in%20Africa%2C%20mechanics%20working%20on%20cars%2C%20hydraulic%20lifts%2C%20tool%20cabinets%2C%20clean%20organized%20workshop%2C%20professional%20automotive%20photography&width=1200&height=500&seq=biz-cover-8&orientation=landscape',
    description: 'Garage automobile multimarques à Kara. Mécanique générale, carrosserie, peinture, entretien, diagnostic électronique. Pièces détachées neuves et occasions. Devis gratuit.',
    categoryId: '10',
    categoryName: 'Garages',
    city: 'Kara',
    country: 'Togo',
    address: 'Route de Kandé, Kara',
    phone: '+228 90 23 45 67',
    email: 'autopluskara@gmail.com',
    website: '',
    rating: 4.1,
    reviewCount: 52,
    isVerified: false,
    status: 'active',
    openingHours: [
      { day: 'Lundi - Samedi', hours: '07h30 - 18h00' },
    ],
    socialLinks: { facebook: 'https://facebook.com/autopluskara' },
  },
  {
    id: '9',
    slug: 'supermarche-leader-price',
    name: 'Leader Price Lomé',
    logoUrl: 'https://readdy.ai/api/search-image?query=Supermarket%20chain%20logo%20emblem%2C%20shopping%20cart%20with%20star%2C%20green%20and%20yellow%20on%20dark%20background%2C%20retail%20brand%20design&width=200&height=200&seq=biz-logo-9&orientation=squarish',
    coverUrl: 'https://readdy.ai/api/search-image?query=Large%20supermarket%20interior%20in%20Africa%2C%20bright%20aisles%20with%20products%2C%20fresh%20produce%20section%2C%20customers%20shopping%2C%20modern%20retail%20environment%2C%20professional%20photography&width=1200&height=500&seq=biz-cover-9&orientation=landscape',
    description: 'Supermarché moderne au cœur de Lomé. Alimentation, produits frais, électronique, textile, articles de maison. Promotions hebdomadaires, carte de fidélité, parking gratuit.',
    categoryId: '4',
    categoryName: 'Supermarchés',
    city: 'Lomé',
    country: 'Togo',
    address: 'Boulevard de la République, Lomé',
    phone: '+228 22 26 30 30',
    email: 'contact@leaderprice.tg',
    website: '',
    rating: 4.0,
    reviewCount: 267,
    isVerified: true,
    status: 'active',
    openingHours: [
      { day: 'Lundi - Samedi', hours: '07h30 - 20h00' },
      { day: 'Dimanche', hours: '08h00 - 14h00' },
    ],
    socialLinks: { facebook: 'https://facebook.com/leaderpricetogo' },
  },
  {
    id: '10',
    slug: 'agence-immobiliere-patrimoine',
    name: 'Patrimoine Immobilier',
    logoUrl: 'https://readdy.ai/api/search-image?query=Real%20estate%20agency%20logo%20emblem%2C%20house%20with%20key%20symbol%2C%20teal%20and%20gold%20on%20dark%20background%2C%20property%20professional%20design&width=200&height=200&seq=biz-logo-10&orientation=squarish',
    coverUrl: 'https://readdy.ai/api/search-image?query=Modern%20real%20estate%20office%20exterior%20in%20Africa%2C%20glass%20front%20building%2C%20luxury%20homes%20display%2C%20palm%20trees%2C%20professional%20property%20photography%2C%20daylight&width=1200&height=500&seq=biz-cover-10&orientation=landscape',
    description: 'Agence immobilière de référence au Togo. Location, vente et gestion de biens immobiliers. Appartements, villas, terrains, bureaux. Accompagnement juridique complet.',
    categoryId: '12',
    categoryName: 'Agences immobilières',
    city: 'Lomé',
    country: 'Togo',
    address: 'Avenue de la Présidence, Lomé',
    phone: '+228 90 55 44 33',
    email: 'contact@patrimoineimmo.tg',
    website: 'https://patrimoineimmo.tg',
    rating: 4.3,
    reviewCount: 68,
    isVerified: true,
    status: 'active',
    openingHours: [
      { day: 'Lundi - Vendredi', hours: '08h00 - 17h30' },
      { day: 'Samedi', hours: '09h00 - 13h00' },
    ],
    socialLinks: { facebook: 'https://facebook.com/patrimoineimmo', instagram: 'https://instagram.com/patrimoineimmo' },
  },
  {
    id: '11',
    slug: 'maquis-du-port',
    name: 'Maquis du Port',
    logoUrl: 'https://readdy.ai/api/search-image?query=Traditional%20African%20restaurant%20logo%20emblem%2C%20palm%20tree%20and%20sun%2C%20warm%20orange%20and%20green%20on%20dark%20background&width=200&height=200&seq=biz-logo-11&orientation=squarish',
    coverUrl: 'https://readdy.ai/api/search-image?query=Traditional%20African%20maquis%20restaurant%20outdoor%20seating%2C%20thatched%20roof%2C%20wooden%20tables%2C%20beach%20view%2C%20colorful%20decorations%2C%20warm%20evening%20atmosphere%2C%20professional%20photography&width=1200&height=500&seq=biz-cover-11&orientation=landscape',
    description: 'Authentique maquis togolais en bord de mer. Poisson braisé, alloco, pâte rouge, grillades, bière locale. Ambiance conviviale, musique live le week-end. Un incontournable de Lomé.',
    categoryId: '1',
    categoryName: 'Restaurants',
    city: 'Lomé',
    country: 'Togo',
    address: 'Route du Port, Lomé',
    phone: '+228 90 11 22 33',
    email: '',
    website: '',
    rating: 4.6,
    reviewCount: 203,
    isVerified: false,
    status: 'active',
    openingHours: [
      { day: 'Lundi - Dimanche', hours: '10h00 - 02h00' },
    ],
    socialLinks: { facebook: 'https://facebook.com/maquisduport' },
  },
  {
    id: '12',
    slug: 'boutique-afrique-chic',
    name: 'Afrique Chic',
    logoUrl: 'https://readdy.ai/api/search-image?query=African%20fashion%20boutique%20logo%20emblem%2C%20abstract%20woman%20silhouette%20in%20wax%20print%20pattern%2C%20vibrant%20colors%20on%20dark%20background&width=200&height=200&seq=biz-logo-12&orientation=squarish',
    coverUrl: 'https://readdy.ai/api/search-image?query=Colorful%20African%20fashion%20boutique%20interior%2C%20traditional%20wax%20print%20fabrics%20displayed%2C%20mannequins%20in%20modern%20African%20designs%2C%20warm%20lighting%2C%20elegant%20retail%20space%2C%20professional%20photography&width=1200&height=500&seq=biz-cover-12&orientation=landscape',
    description: 'Boutique de mode africaine contemporaine. Pagnes wax, tenues sur mesure, accessoires artisanaux, bijoux. Design unique mêlant tradition et modernité. Livraison internationale.',
    categoryId: '11',
    categoryName: 'Boutiques',
    city: 'Lomé',
    country: 'Togo',
    address: 'Rue des Artisans, Lomé',
    phone: '+228 90 66 77 88',
    email: 'contact@afriquechic.tg',
    website: 'https://afriquechic.tg',
    rating: 4.5,
    reviewCount: 87,
    isVerified: true,
    status: 'active',
    openingHours: [
      { day: 'Lundi - Samedi', hours: '09h00 - 19h00' },
    ],
    socialLinks: { instagram: 'https://instagram.com/afriquechic', facebook: 'https://facebook.com/afriquechic' },
  },
];